import type { OverrideProperties } from 'type-fest';

export const taskRunToastTypeByStatus = {
  Success: 'success',
  Error: 'error',
  InProgress: 'info',
} as const;

type TaskRunStatus = keyof typeof taskRunToastTypeByStatus;

// Task names as the source of truth
export const taskRunNames = [
  'generate_reward_letter',
  'copy_from_employee_v2',
  'sync_from_employee_v2',
  'excel_formula_execution',
  'delete_change_history',
  'clone_cycle',
  'bulk_delete_employee',
] as const;

// Derive task name type directly from the array
export type TaskRunName = (typeof taskRunNames)[number];

// Base type with all tasks having empty details
type BaseTaskRunDetailsMap = Record<TaskRunName, Record<string, never>>;

// Override specific task with custom details
type TaskRunDetailsMap = OverrideProperties<
  BaseTaskRunDetailsMap,
  {
    generate_reward_letter: { reward_letter_id: number; employee_id: number };
  }
>;

// Base task run status v2 structure without details
type TaskRunBase = {
  task_id: number;
  status: TaskRunStatus;
  toast_message: string;
  progress_message: string;
  progress_bar_show: boolean;
  progress_percent: number;
  cycle_id: number;
  user_id_initiated: number;
  // A derived boolean from the status variable above, provided for convenience.
  isDone: boolean;
  isInProgress: boolean;
};

// Combined type that maps each task name to its full structure including specific details
export type TaskRun<T extends TaskRunName = TaskRunName> = TaskRunBase & {
  task_name: T;
  details: TaskRunDetailsMap[T];
};
